import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { authorizedFetch } from '@/lib/queryClient';
import { useState } from 'react';

export default function OutOfCreditsDialog({ open, onClose, resetAt }: { open: boolean; onClose: () => void; resetAt?: string }) {
  const [billingCycle, setBillingCycle] = useState<'monthly'|'yearly'>('monthly');

  async function handleUpgrade() {
    try {
      const res = await authorizedFetch('/api/config');
      const cfg = await res.json();
      const priceId = billingCycle === 'yearly'
        ? cfg.stripe?.pricePlusYearly
        : cfg.stripe?.pricePlusMonthly;
      if (!priceId) return;
      const resp = await authorizedFetch('/api/billing/checkout', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ priceId }) });
      const out = await resp.json();
      if (out?.url) window.location.assign(out.url);
    } catch {}
  }

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Out of credits</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <p>You don't have enough credits to generate a new plot.</p>
          {resetAt && <p>Monthly credits reset on {new Date(resetAt).toLocaleString()}.</p>}
          <div className="flex items-center gap-2 pt-2">
            <Button variant={billingCycle==='monthly'?'default':'outline'} size="sm" onClick={() => setBillingCycle('monthly')}>Monthly</Button>
            <Button variant={billingCycle==='yearly'?'default':'outline'} size="sm" onClick={() => setBillingCycle('yearly')}>Yearly</Button>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={handleUpgrade}>Upgrade</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}


